import { Model } from 'dva'
import { ASRProvider } from '../types'
import { AsrService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const ASRProviders: Model = {
  namespace: 'asrProviders',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let asrProviders = yield select((state: any) => state.asrProviders.list)
        if (!(asrProviders.length > 0 && useCache)) {
          asrProviders = yield call(AsrService.asrList, {})
          yield put({ type: 'modifyList', payload: asrProviders })
        }
        onSuccess(asrProviders)
      } catch (err: any) {
        FailureHandler('Error fetching ASR Providers', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let asrProvider = yield select((state: any) =>
          state.asrProviders.list.find((asrProvider: ASRProvider) => asrProvider.id === id)
        )
        if (!asrProvider) {
          asrProvider = yield call(AsrService.asrRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: asrProvider })
        onSuccess(asrProvider)
      } catch (err) {
        FailureHandler('Could not find the ASR Provider!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(AsrService.asrCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a ASR Provider!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(AsrService.asrPartialUpdate, { id: id, requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a ASR Provider!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(AsrService.asrDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a asrProvider', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: ASRProvider) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: ASRProvider) => !action.payload.map((p: ASRProvider) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: ASRProvider) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetASRProvider(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default ASRProviders
